type PluralizeProps = {
  count?: number;
  one: string;
  few: string;
  many: string;
  skipOneCount?: boolean;
  skipCount?: boolean;
};

export const pluralize = ({
  count,
  one,
  few,
  many,
  skipOneCount = false,
  skipCount = false,
}: PluralizeProps): string => {
  if (!count) return '';

  const mod10 = count % 10;
  const mod100 = count % 100;

  const countToShow = skipCount ? '' : skipOneCount && count === 1 ? '' : count;

  if (mod10 === 1 && mod100 !== 11) return `${countToShow} ${one}`;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20))
    return `${countToShow} ${few}`;

  return `${countToShow} ${many}`;
};
